/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-08 11:12:10
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-06 17:19:17
 * @FilePath: /unifyxp-v2-store-portal/src/components/LinkModule/index.tsx
 */
import { Input, OriSelect } from '@/src/components/Antd';
import Configuration from '@/src/components/Configuration/Configuration';
import { getConfig } from '@/src/constrains/GlobalProvider/slice';
import { createExternalLink } from '@/src/request/link';
import { Icon } from '@/src/tools/icon';
import {
  EnumActionType,
  LinkModuleType,
  EnumLinkType,
} from '@/src/types/common/linkType';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import {
  useClickAway,
  useDebounceEffect,
  useDebounceFn,
  useRequest,
} from 'ahooks';
import classname from 'classnames';
import lodash, { get } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { checkIsInternal } from 'src/components/LinkModule/hooks';
import { useSalesChannelIsMiniProgram } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import {
  Head,
  ItemWithIcon,
  ItemWithPic,
  Loading,
  NoResult,
  TextItem,
  Title,
} from './Components';
import styles from './style.module.less';
import {
  categorizeLinkLibrary,
  fetchData,
  spliceProductDesc,
  transform,
  urlValidate,
} from './util';
import { generateNoneLinkData } from 'src/constrains/LinkLibrary/tools';

type Props = {
  value: LinkValue;
  middleText?: string;
  linkTypeFilter?: Array<string>;
  scopeVariables?: Record<any, string>;
  onChange: (type: LinkValue) => void;
  extraLinkTypeFilter?: Array<string>;
  selectedLinkType?: Array<any>;
  excludeLinkType?: Array<any>;
  fetchProps?: { [propsName: string]: any };
  cannotAddToCart?: boolean;
  unableDelete?: boolean;
  salesChannelSelectProps?: any;
  header?: React.ReactElement;
};

type LinkValue = {
  label: string;
  uuid: string;
  linkType: LinkModuleType | EnumLinkType;
  action: string;
  salesChannelUuid?: string;
  draggableId?: string;
  linkImage?: any;
  item?: any;
};

function LinkModule(props: Props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    middleText,
    linkTypeFilter,
    onChange,
    scopeVariables,
    value,
    selectedLinkType,
    fetchProps,
    excludeLinkType,
    unableDelete,
    salesChannelSelectProps,
    header,
  } = props;

  const selectSalesChannelUuid = get(
    salesChannelSelectProps,
    'selectSalesChannelUuid',
  );
  const selectableSalesChannels = get(
    salesChannelSelectProps,
    'selectableSalesChannels',
  );
  const onSelectSalesChannelChange = get(
    salesChannelSelectProps,
    'onSelectSalesChannelChange',
  );

  // const hideSelect =
  //   !selectSalesChannelUuid || (selectableSalesChannels || []).length < 2;

  const isMiniProgram = useSalesChannelIsMiniProgram();
  //除了home page/all product/cart/profile/customer service/none/product/collection/content page/legal page
  //以外的所有链接
  // console.log('v', value);
  const displayMiniProgramExternalTip = () => {
    const { linkType, uuid } = value || {};
    const isInternal = checkIsInternal(linkType, uuid);
    if (!linkType) {
      return false;
    }
    if (isMiniProgram && !isInternal) {
      return true;
    }
    return false;
  };
  // console.log('selectedLinkType', selectedLinkType);
  const ref = useRef<HTMLDivElement>();

  const [v, setV] = useState('');

  const [loading, setLoading] = useState(false);

  const [showOverlay, setShowOverlay] = useState(false);
  //console.log('showOverlay', showOverlay);

  const [popState, setPopState] = useState({ level: 0, linkType: '' });

  const [dataSet, setData] = useState([]);

  const linkTypeList: Array<any> = useSelector(getConfig());

  const convertLinkTypeFilterToObject = (linkTypeFilter) => {
    return (linkTypeFilter || []).reduce((p, c: any) => {
      if (typeof c === 'string') {
        const linkTypeItem = linkTypeList.find(
          (item) => item.name === c || item.linkType === c,
        );
        if (linkTypeItem) {
          return p.concat(linkTypeItem);
        }
      } else {
        if (c.linkType && c.name) {
          return p.concat(c);
        }
      }
      return p;
    }, []);
  };

  const generateLinkType = () => {
    if (selectedLinkType) {
      //selectedLinkType 和 linkTypeFilter 其实是一样的
      return selectedLinkType;
    } else if ((excludeLinkType || []).length > 0) {
      const list =
        (linkTypeFilter || []).length !== 0
          ? convertLinkTypeFilterToObject(linkTypeFilter)
          : linkTypeList;
      const nameList = (excludeLinkType || []).map((i) => get(i, 'linkType'));
      const res = list.filter((l) => {
        if (
          nameList.includes(LinkModuleType.SysModule) &&
          l.linkType === LinkModuleType.SysModule
        ) {
          const sysModule = excludeLinkType.find((i) => {
            return get(i, 'linkType') === LinkModuleType.SysModule;
          });
          const groups = get(sysModule, 'groups') || [];

          if (groups.length === 0) {
            return false;
          } else {
            const name = get(l, 'name');
            return !groups.includes(name);
          }
        }
        return !nameList.includes(l.linkType);
      });
      return res;
    } else if ((linkTypeFilter || []).length !== 0) {
      return convertLinkTypeFilterToObject(linkTypeFilter);
    } else {
      return linkTypeList;
    }
  };

  const list = generateLinkType();
  const handleClickLinkType = (type: any, e: any) => {
    e.stopPropagation();
    if (type.additional) {
      setPopState({ level: 1, linkType: type.linkType });
    } else {
      onChange({
        ...transform(type),
        salesChannelUuid: selectSalesChannelUuid,
      });
      setShowOverlay(false);
    }
  };

  const handleChange = (value: LinkValue) => {
    onChange(value);
    setV(value.label);
    setShowOverlay(false);
  };

  const handleDeleteValue = (e: any) => {
    e.stopPropagation();
    setShowOverlay(true);
    setPopState({ level: 0, linkType: '' });
    onChange(generateNoneLinkData());
  };

  const handleGoBack = (e: any) => {
    e.stopPropagation();
    setPopState({ level: 0, linkType: '' });
  };

  const handleSearch = async (value: any) => {
    setV(value);

    if (value) {
      setPopState({ level: 0, linkType: '' });
    } else {
      fetchSearchResult(value);
    }
  };

  const handleFocus = () => {
    setShowOverlay(true);
    setV('');
  };

  const handleBlur = () => {
    setV(value.label);
  };

  const handleAddExternalLink = async (value: string) => {
    const res: any = await createExternalLink({
      category: 'URL',
      title: value,
      url: /http(s?):\/\//.test(value)
        ? value.replace(/http(s?):\/\//, '//')
        : `//${value}`,
    });
    setPopState({ level: 1, linkType: LinkModuleType.LinkLibrary });
    onChange({
      salesChannelUuid: selectSalesChannelUuid,
      label: res.title,
      uuid: res.uuid,
      linkType: LinkModuleType.LinkLibrary,
      action: null,
      item: {
        ...res,
        hasError: false,
      },
    });
    setV(res.title);
    setShowOverlay(false);
  };

  const { run: _fetchSearchResult } = useRequest(
    (value: any) => {
      //  console.log('v', value);

      return fetchData(null, scopeVariables, value, fetchProps);
    },
    {
      manual: true,
      debounceInterval: 1000,
      onSuccess: (response: any, params: any) => {
        const [value] = params;
        if (
          Array.isArray(response) &&
          response.some((i) => Array.isArray(i.items) && i.items.length !== 0)
        ) {
          setPopState({ level: 1, linkType: '' });
          setData(response);
        } else if (urlValidate(value)) {
          setPopState({ level: 1, linkType: '' });
          setData([{ linkType: 'ExternalLink', value }]);
        } else {
          setPopState({ level: 1, linkType: '' });
          setData([]);
        }
      },
    },
  );
  const { run: fetchSearchResult } = useDebounceFn(
    (v) => {
      _fetchSearchResult(v);
    },
    {
      wait: 500,
    },
  );
  // useCallback(
  //   lodash.debounce(async (value: any) => {
  //     if (value) {
  //       const response = await fetchData(null, scopeVariables, value);
  //       if (
  //         Array.isArray(response) &&
  //         response.some((i) => Array.isArray(i.items) && i.items.length !== 0)
  //       ) {
  //         setPopState({ level: 1, linkType: '' });
  //         setData(response);
  //       } else if (urlValidate(value)) {
  //         setPopState({ level: 1, linkType: '' });
  //         setData([{ linkType: 'ExternalLink', value }]);
  //       } else {
  //         setPopState({ level: 1, linkType: '' });
  //         setData([]);
  //       }
  //     } else {
  //       setPopState({ level: 0, linkType: '' });
  //     }
  //   }, 500),
  //   [lodash.debounce],
  // );

  useDebounceEffect(() => {
    if (value) {
      const { label, linkType } = value;
      setV(label);
      setPopState({
        level:
          value && value.uuid && linkType !== LinkModuleType.SysModule ? 1 : 0,
        linkType,
      });
    }
  }, [value]);

  useEffect(() => {
    if (!showOverlay) {
      if (value) {
        const { label, linkType } = value;
        setV(label);
        setPopState({
          level:
            value && value.uuid && linkType !== LinkModuleType.SysModule
              ? 1
              : 0,
          linkType,
        });
      }
    }
  }, [showOverlay]);

  useDebounceEffect(() => {
    if (popState.level > 0) {
      if (popState.linkType) {
        setLoading(true);
        fetchData(popState.linkType, scopeVariables, null, fetchProps) //500报错这里
          .then((res) => {
            setData(res);
            setLoading(false);
          })
          .finally(() => setLoading(false));
      }
    }
  }, [popState]);

  useClickAway(() => {
    setShowOverlay(false);
  }, ref);

  const renderOverlay = () => {
    if (loading) {
      return <Loading />;
    } else {
      if (dataSet.length === 1) {
        const list = lodash.get(dataSet[0], 'items', []) || [];
        const linkType = lodash.get(dataSet[0], 'linkType', '') || '';
        if (linkType === 'ExternalLink') {
          const value = lodash.get(dataSet[0], 'value', '');
          return (
            <div>
              <TextItem
                title={value}
                onClick={handleAddExternalLink.bind(null, value)}
              />
            </div>
          );
        } else {
          return (
            <div>
              <Title
                title={middleText || popState.linkType}
                rightElement={
                  popState.linkType === LinkModuleType.LinkLibrary ? (
                    <Link to={'/settings/linkLibrary'} className={styles.link}>
                      {getI18nFromGeneral('general.sider.linkLibrary')}
                    </Link>
                  ) : null
                }
                totalCount={list.length}
                onBack={handleGoBack}
              />
              {renderList(list, linkType)}
            </div>
          );
        }
      }
      if (dataSet.length > 1) {
        return (
          <div>
            {dataSet.map((set) => {
              const { linkType, items = [] } = set;
              return (
                <div key={linkType}>
                  {items.length !== 0 && (
                    <>
                      <Head title={linkType} count={items.length || 0} />
                      {renderList(items, linkType)}
                    </>
                  )}
                </div>
              );
            })}
          </div>
        );
      } else {
        return <NoResult></NoResult>;
      }
    }
  };

  const renderList = (list: Array<any>, linkType: string) => {
    switch (linkType) {
      case LinkModuleType.Product: {
        return (
          <>
            {list.length === 0 && <NoResult></NoResult>}
            {list.map((item) => {
              return (
                <ItemWithPic
                  selected={value.uuid === item.uuid}
                  key={item.uuid}
                  image={item.imageUrl}
                  title={item.productName}
                  desc={spliceProductDesc(item)}
                  onClick={handleChange.bind(this, {
                    label: item.productName,
                    uuid: item.uuid,
                    action: EnumActionType.ProductDetail,
                    linkType: LinkModuleType.Product,
                    item: {
                      ...item,
                      hasError: false,
                    },
                    salesChannelUuid: selectSalesChannelUuid,
                  })}
                />
              );
            })}
          </>
        );
      }
      case LinkModuleType.LegalPage: {
        return (
          <>
            {list.length === 0 && <NoResult />}
            {list.map((item) => (
              <TextItem
                selected={value.uuid === item.uuid}
                key={item.uuid}
                title={item.name}
                desc={item.versionRemarks}
                onClick={handleChange.bind(this, {
                  label: item.name,
                  uuid: item.uuid,
                  action: null,
                  linkType: LinkModuleType.LegalPage,
                  salesChannelUuid: item.salesChannelUuid,
                  item: {
                    ...item,
                    hasError: false,
                  },
                })}
              />
            ))}
          </>
        );
      }
      case LinkModuleType.ContentPage: {
        return (
          <>
            {list.length === 0 && <NoResult />}
            {list.map((item) => (
              <TextItem
                selected={value.uuid === item.uuid}
                key={item.uuid}
                title={item.name}
                onClick={handleChange.bind(this, {
                  label: item.name,
                  uuid: item.uuid,
                  action: null,
                  linkType: LinkModuleType.ContentPage,
                  salesChannelUuid: item.salesChannelUuid,
                  item: {
                    ...item,
                    hasError: false,
                  },
                })}
              />
            ))}
          </>
        );
      }
      case LinkModuleType.Collection: {
        return (
          <>
            {list.length === 0 && <NoResult />}
            {list.map((item) => (
              <TextItem
                selected={value.uuid === item.uuid}
                key={item.uuid}
                title={item.collectionName}
                onClick={handleChange.bind(this, {
                  label: item.collectionName,
                  uuid: item.uuid,
                  action: null,
                  linkType: LinkModuleType.Collection,
                  salesChannelUuid: item.salesChannelUuid,
                  item: {
                    ...item,
                    hasError: false,
                  },
                })}
              />
            ))}
          </>
        );
      }
      case LinkModuleType.LinkLibrary: {
        const lists = categorizeLinkLibrary(list);
        const { urlList, miniProgram } = lists;
        return (
          <>
            {list.length === 0 && <NoResult />}
            {urlList.length !== 0 && (
              <>
                <Head title={'URL'} count={urlList.length} />
                {urlList.map((item) => {
                  return (
                    <TextItem
                      selected={value.uuid === item.uuid}
                      key={item.uuid}
                      title={`${item.title}${
                        item.language ? ` (${item.language})` : ''
                      }`}
                      desc={
                        item.relatedMiniProgram ? (
                          <span className={styles.leaf}>
                            <Icon type='iconlink' className={styles.iconLink} />
                            <span>{`${item.relatedMiniProgram.title}${
                              item.relatedMiniProgram.language
                                ? ` (${item.relatedMiniProgram.language})`
                                : ''
                            }`}</span>
                          </span>
                        ) : null
                      }
                      onClick={handleChange.bind(this, {
                        label: `${item.title}${
                          item.language ? ` (${item.language})` : ''
                        }`,
                        action: null,
                        uuid: item.uuid,
                        linkType: LinkModuleType.LinkLibrary,
                        salesChannelUuid: selectSalesChannelUuid,
                        item: {
                          ...item,
                          hasError: false,
                        },
                      })}
                    />
                  );
                })}
              </>
            )}
            {miniProgram.length !== 0 && (
              <>
                <Head
                  title={getI18n('general.miniProgram')}
                  count={miniProgram.length}
                />
                {miniProgram.map((item) => {
                  return (
                    <TextItem
                      selected={value.uuid === item.uuid}
                      key={item.uuid}
                      title={`${item.title}${
                        item.language ? ` (${item.language})` : ''
                      }`}
                      onClick={handleChange.bind(this, {
                        label: `${item.title}${
                          item.language ? ` (${item.language})` : ''
                        }`,
                        action: null,
                        uuid: item.uuid,
                        linkType: LinkModuleType.LinkLibrary,
                        item: {
                          ...item,
                          hasError: false,
                        },
                      })}
                    />
                  );
                })}
              </>
            )}
          </>
        );
      }
      default: {
        return;
      }
    }
  };

  return (
    <React.Fragment>
      {selectableSalesChannels.length > 1 && (
        <ItemWrapper title={getI18n('general.selectSalesChannel')}>
          <OriSelect
            size='large'
            className={styles.scSelect}
            value={selectSalesChannelUuid}
            onChange={onSelectSalesChannelChange}>
            {(selectableSalesChannels || []).map((i) => {
              const uuid = get(i, 'uuid');
              const name = get(i, 'name');
              return (
                <OriSelect.Option value={uuid} key={uuid}>
                  {name}
                </OriSelect.Option>
              );
            })}
          </OriSelect>
        </ItemWrapper>
      )}

      {/* {!hideSelect && (
        <OriSelect
          value={selectSalesChannelUuid}
          onChange={onSelectSalesChannelChange}>
          {(selectableSalesChannels || []).map((i) => {
            const uuid = get(i, 'uuid');
            const name = get(i, 'name');
            return (
              <OriSelect.Option value={uuid} key={uuid}>
                {name}
              </OriSelect.Option>
            );
          })}
        </OriSelect>
      )} */}
      <span className={styles.linkTitle}> {header}</span>
      <div className={styles.container} ref={ref}>
        <Input
          style={{ borderColor: value.item?.hasError ? '#FF695F' : undefined }}
          className={styles.input}
          fullyControlledFilter={(v) => v}
          placeholder={getI18n('general.linkModule.placeholder')}
          onChange={handleSearch}
          suffix={
            value &&
            (value.uuid || value.linkType === 'None') &&
            !unableDelete ? (
              <Icon
                type='iconclose'
                className={styles.icon}
                onClick={handleDeleteValue}
              />
            ) : (
              <span />
            )
          }
          value={v}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
        {displayMiniProgramExternalTip() && (
          <div className={styles.tip}>
            <Configuration
              hideRarePart
              configStart={getI18n('general.linkModule.config')}
            />
          </div>
        )}

        <div
          className={classname(styles.overlay, {
            [styles.visible]: showOverlay,
          })}>
          {popState.level === 0 && (
            <div>
              {list.map((type) => {
                return type.additional ? (
                  <ItemWithIcon
                    key={type.uuid || type.name}
                    title={type.name}
                    onClick={handleClickLinkType.bind(this, type)}
                  />
                ) : (
                  <TextItem
                    selected={
                      value.uuid === type.uuid && value.label === type.name
                    }
                    key={type.uuid || type.name}
                    title={type.name}
                    onClick={handleClickLinkType.bind(this, type)}
                  />
                );
              })}
            </div>
          )}
          {popState.level === 1 && renderOverlay()}
        </div>
      </div>
    </React.Fragment>
  );
}

export default LinkModule;
